// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3sIoj","amount":"Amount_amount__fcoBD","tip":"Amount_tip__3bXs5","tipHeader":"Amount_tipHeader__3dC_z","tipsWrap":"Amount_tipsWrap__3mvcr"};